<template>
  <div>
    <b-row>
      <b-col
        xl="3"
        lg="4"
        md="5"
      >
        <FormCardProfileVue :loading="loading" />
      </b-col>
      <b-col
        xl="9"
        lg="8"
        md="7"
      >
        <b-tabs lazy>
          <b-tab
            v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')"
            :active="!$route.query.tab || $route.query.tab === 'empresa'"
          >
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Empresa</span>
            </template>
            <FormVue :loading="loading" />
          </b-tab>

          <b-tab
            v-if="verificarPermissao('ROLE_FINAN_CONSULTAR')"
            :active="$route.query.tab === 'financeiro'"
          >
            <template #title>
              <feather-icon icon="DollarSignIcon" />
              <span>Financeiro</span>
            </template>
            <FormFinacialVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileTextIcon" />
              <span>Documentos</span>
            </template>
            <FormDocumentationsVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_RELATORIO_CONSULTAR')">
            <template #title>
              <feather-icon icon="PrinterIcon" />
              <span>Relatorios</span>
            </template>
            <FormReportsVue />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'

import mixinsGlobal from '@/mixins'

const FormVue = () => import('./forms/personal/FormFornecedor.vue')
const FormFinacialVue = () => import('./forms/finance/FormFinancial.vue')
const FormDocumentationsVue = () => import('./forms/documentations/FormDocumentations.vue')
const FormReportsVue = () => import('./forms/report/GridReport.vue')
const FormCardProfileVue = () => import('./forms/personal/FormCardProfileFornecedor.vue')

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    FormCardProfileVue,
    FormVue,
    FormFinacialVue,
    FormDocumentationsVue,
    FormReportsVue,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    this.loading = true
    const allPrimis = []
    let fornecedorPromise = null

    try {
      // 1. Inicia todas as chamadas de combos em paralelo
      if (this.verificarPermissao('ROLE_UF_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('combosModule/loadComboUfs'))
      }
      if (this.verificarPermissao('ROLE_PREVIDENCIA_SOCIAL_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('combosModule/loadComboPrevidenciaSocial'))
      }
      if (this.verificarPermissao('ROLE_TIPO_ENDERECO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('combosModule/loadComboTipoEndereco'))
      }
      if (this.verificarPermissao('ROLE_ADMIM_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('fornecedorAdministrativeModule/loadComboTypesRegister'))
        allPrimis.push(this.$store.dispatch('combosModule/loadComboNaturezaFiscal'))
      }

      // 2. Inicia a busca dos dados do fornecedor em paralelo
      if (this.verificarPermissao('ROLE_ADMIM_CONSULTAR')) {
        fornecedorPromise = this.$store.dispatch(
          'fornecedorAdministrativeModule/getFornecedorID',
          this.$route.params.id,
        )
      }

      // 3. Aguarda o término de todas as requisições paralelas
      const results = await Promise.all([...allPrimis, fornecedorPromise].filter(p => p !== null))

      // 4. Se buscou o fornecedor, processa os dados e prepara a edição
      if (fornecedorPromise) {
        const response = await fornecedorPromise
        const object = response.data
        if (object.foto) {
          object.foto = `data:image/jpeg;base64,${object.foto}`
        }
        await this.$store.dispatch(
          'fornecedorAdministrativeModule/prepareToEditFull',
          object,
        )
      }

      this.loading = false
    } catch (error) {
      console.error(error)
      this.MensagemError('Error', 'Erro ao carregar dados da tela!')
      this.loading = false
      this.$router.go(-1)
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
